import'../sass/Name.scss'
function Name(){
    return <div className='name' id='name'>
        <div className='intro'><h1 className='green'>LILIAN<br></br>SCHOTT</h1></div>
        <br></br>
        <h2>ETUDIANT EN<br></br> DEVELOPPEMENT<br></br>WEB</h2>
        </div>
}
export default Name